module.exports = __webpack_public_path__ + "static/media/projector_on.3c5f1305.png";